/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {SearchOutlined} from '@ant-design/icons';
import {Flex, Input, InputRef, Table as TableAnt} from 'antd';
import {ColumnsType, ColumnType} from 'antd/es/table';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {ReactComponent as Location} from '../../../../../assets/icons/Location_icon.svg';
import PilComp from '../../../../../components/DisplayComponent/PilComp';
import {objTypes} from '../../../../../components/DrawerForm/Constants/commonConstants';
import DrawerForm from '../../../../../components/DrawerForm/Utils/DrawerForm';
import EFDBForm from '../../../../../components/Forms/EFDBForm';
import Loader from '../../../../../components/Loader/Loader';
import {Title} from '../../../../../components/Table/Constants/Common';
import {defaultCol} from '../../../../../components/Table/Interface/ITable';
import ActionsButton from '../../../../../components/Table/Utils/ActionsButton';
import {ISelect} from '../../../../../interface/ISelect';
import {APITypeEnum} from '../../../../../services/interface/tableAPIType';
import efdDatabaseAPI from '../../../../../services/modules/Configurator/efdDatabase';
import country from '../../../../../services/modules/JSON/country';
import efdbJson from '../../../../../services/modules/JSON/efdbJson';
import facilityDetailsDropdown from '../../../../../services/modules/OM/facilityDetails';
import Year from '../../../../../shared/Year';
import useCompanyStore from '../../../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../../../store/StaticJson/jsonStore';
import useUserStore from '../../../../../store/userStore/userStore';
// import useJSONStore from '../../../../../store/StaticJson/jsonStore';
import {checkCurrentYearOrBelow} from '../../../../../utils/commonFunctions';
import {yearSelect} from '../../../../../utils/FormUtils/yearSelect';
import {DataType} from '../../../../activityLog/interface/activityLog';

import {EFDBKey, EFDBLabel} from './constants/commonConstants';
import {IEmissionFactorDatabase} from './interface/IEFDB';

const EFDatabase: React.FC = () => {
  const companyId = useCompanyStore.getState().companyId;
  const efdb = useJSONStore.getState().efdbJSON;
  const [dataSource, setDataSource] = useState([]);
  const [editData, setEditData] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const allFacility = useCompanyStore.getState()?.facilityDetails;
  const countryOptions = useJSONStore((state) => state.country);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);

  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');

  const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
    Promise.all([
      facilityDetailsDropdown(APITypeEnum.GET_ALL, true),
      country(),
      efdbJson()
    ])
      .then(() => {})
      .catch(() => {
        setDataSource([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const searchInput = useRef<InputRef>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const SearchFilter = (
    title: string,
    dataIndex: keyof any,
    option: ISelect[] | undefined = undefined
  ): defaultCol & ColumnType<any> => {
    return {
      filterDropdown: ({selectedKeys, setSelectedKeys, confirm}) => {
        return (
          <div
            style={{padding: 8}}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          >
            <Input
              ref={searchInput}
              value={selectedKeys[0]}
              placeholder={`Search ${title}`}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
              allowClear
            />
          </div>
        );
      },
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => {
        if (option) {
          const filtered = option.filter((item) => {
            if (typeof item?.label === 'string') {
              return item?.label
                .toString()
                .toLowerCase()
                .includes(value.toString().toLowerCase());
            } else {
              return [];
            }
          });

          return filtered?.some((item) => {
            return item?.value === record[dataIndex];
          });
        } else {
          return record[dataIndex]
            ?.toString()
            .toLowerCase()
            .includes(value?.toString().toLowerCase());
        }
      },
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      }
    };
  };

  const efdbPreview = useMemo(() => {
    return [
      {
        key: EFDBKey.year,
        label: EFDBLabel.year,
        type: objTypes.string
      },
      {
        key: EFDBKey.facilityId,
        label: EFDBLabel.facilityName,
        type: objTypes.json,
        format:
          allFacility?.[selectedYear]?.map((item: any) => {
            return {label: item?.name, value: item?._id};
          }) ?? []
      },
      {
        key: EFDBKey.scope1,
        label: EFDBLabel.scope1,
        type: objTypes.json,
        format: efdb
      },
      {
        key: EFDBKey.scope2,
        label: EFDBLabel.scope2,
        type: objTypes.json,
        format: efdb
      },
      {
        key: EFDBKey.scope3,
        label: EFDBLabel.scope3,
        type: objTypes.json,
        format: efdb.map((i) => {
          return i.scope.includes(3) ? {...i, label: `${i.label} / EEIO`} : i;
        })
      }
    ];
  }, [allFacility, selectedYear, efdb]);

  const columns: (defaultCol & ColumnsType<IEmissionFactorDatabase>[0])[] = [
    {
      title: EFDBLabel.facilityName,
      dataIndex: EFDBKey.facilityName,
      ...SearchFilter(
        EFDBLabel.facilityName,
        EFDBKey.facilityName as keyof DataType
      ),
      render: (value, record) => {
        return (
          <Flex align="center" vertical style={{flex: 1}}>
            <div style={{fontWeight: 'bold', alignSelf: 'flex-start'}}>
              {value}
            </div>
            {/* <Flex
              align="center"
              justify="center"
              style={{alignSelf: 'flex-start'}}
            >
              <Location />
              <div>{record.countryName ?? ''}</div>
            </Flex> */}
          </Flex>
        );
      }
      // width: '100px',
    },
    {
      title: EFDBLabel.country,
      dataIndex: EFDBKey.country,
      editable: true,
      type: 'select',
      ...SearchFilter(EFDBLabel.country, EFDBKey.country, countryOptions),
      render: (value) => {
        return (
          <>
            {
              countryOptions.find((item) => {
                return item.value === value;
              })?.label
            }
          </>
        );
      }
    },
    {
      title: EFDBLabel.scope1,
      dataIndex: EFDBKey.scope1,
      // width: '100px',
      render: (value) => {
        const label =
          efdb.find((item) => {
            return item.value === value;
          })?.label ?? '';

        return (
          <PilComp value={label} color="#E6ECF0" style={{fontWeight: 'bold'}} />
        );
      }
    },
    {
      title: EFDBLabel.scope2,
      dataIndex: EFDBKey.scope2,
      // width: '100px',
      render: (value) => {
        const label =
          efdb.find((item) => {
            return item.value === value;
          })?.label ?? '';

        return (
          <PilComp value={label} color="#E6ECF0" style={{fontWeight: 'bold'}} />
        );
      }
    },
    {
      title: EFDBLabel.scope3,
      dataIndex: EFDBKey.scope3,
      render: (value) => {
        const label =
          efdb.find((item) => {
            return item.value === value;
          })?.label ?? '';

        return (
          <PilComp
            value={`${label} / EEIO`}
            color="#E6ECF0"
            style={{fontWeight: 'bold'}}
          />
        );
      }
      // width: '100px',
    },
    {
      title: Title.actionTitle,
      dataIndex: 'operation',
      type: '',
      fixed: 'right',
      width: '200px',
      render: (value, record) => {
        const {countryName, country, name, ...restData} = record;

        return dataSource.length >= 1 ? (
          <ActionsButton
            record={restData}
            setShowModel={setShowModel}
            setEditData={setEditData}
            setIsEdit={setIsEdit}
            isConfigurator={true}
            noDelete={true}
          />
        ) : null;
      }
    }
  ];

  useEffect(() => {
    if (selectedYear !== '') {
      setIsRefresh(true);
      efdDatabaseAPI(
        APITypeEnum.GET_ALL,
        undefined,
        `${companyId}/${
          searchParam.get('selectedYear') ??
          firstYear?.[0].value ??
          selectedYear
        }`
      )
        .then((res) => {
          setDataSource(res ?? []);
        })
        .catch(() => {
          setDataSource([]);
        })
        .finally(() => {
          setIsRefresh(false);
        });
    }
  }, [selectedYear]);

  useEffect(() => {
    if (refresh) {
      setIsRefresh(true);
      efdDatabaseAPI(
        APITypeEnum.GET_ALL,
        undefined,
        `${companyId}/${selectedYear}`
      )
        .then((main) => {
          setDataSource(main);
        })
        .catch(() => {
          setDataSource([]);
        })
        .finally(() => {
          setIsRefresh(false);
          setRefresh(false);
        });
    }
  }, [refresh]);

  return isLoading ? (
    <Loader />
  ) : (
    <div className="efMain">
      {searchParam.get('selectedYear') && (
        <>
          <Year setSelectedYear={setSelectedYear} />
        </>
      )}
      <TableAnt
        // getPopupContainer={(triggerNode) =>
        //   triggerNode.closest(
        //     '.ant-modal, .ant-drawer, [style*="position"]'
        //   ) as HTMLElement
        // }
        rowKey="_id"
        dataSource={dataSource}
        columns={columns as any}
        scroll={{x: 'auto'}}
        loading={{
          indicator: <Loader />,
          spinning: isRefresh
        }}
      />
      <DrawerForm
        open={showModel}
        onCancel={() => {
          setShowModel(false);
        }}
        setRefresh={setRefresh}
        data={isEdit ? editData : undefined}
        FormComponent={<EFDBForm />}
        API={efdDatabaseAPI}
        stepsTitle={['Edit Emission Databases']}
        idKey={`${companyId}/${selectedYear}`}
        table={true}
        onlyYear={true}
        formPreview={efdbPreview}
        isConfigurator={true}
      />
      {/* {isLoading ? (
        <Loader />
      ) : dataSource?.length > 0 ? (
        dataSource?.map((item: any, index: number) => {
          return (
            <Flex
              align="center"
              justify="space-between"
              key={index}
              vertical={false}
              style={{}}
              gap={10}
              className="efSingle"
            >
              <Flex align="center" vertical style={{flex: 1}}>
                <div style={{fontWeight: 'bold', alignSelf: 'flex-start'}}>
                  {item.name}
                </div>
                <Flex
                  align="center"
                  justify="center"
                  style={{alignSelf: 'flex-start'}}
                >
                  <Location />
                  <div>
                    {
                      countries.find((country) => {
                        return country.value === item.country;
                      }).label
                    }
                  </div>
                </Flex>
              </Flex>
              <Flex
                vertical={false}
                align="center"
                //   justify="space-between"
                gap={30}
                style={{width: '100%', alignSelf: 'flex-end', flex: 1}}
              >
                <div
                  style={{
                    padding: '0px 8px',
                    backgroundColor: '#E6ECF0',
                    borderRadius: '100px'
                  }}
                >
                  Scope 1:{' '}
                  <span style={{fontWeight: 'bold'}}>{efData.scope1}</span>
                </div>
                <div
                  style={{
                    padding: '0px 8px',
                    backgroundColor: '#E6ECF0',
                    borderRadius: '100px'
                  }}
                >
                  Scope 2:{' '}
                  <span style={{fontWeight: 'bold'}}>{efData.scope2}</span>
                </div>
                <div
                  style={{
                    padding: '0px 8px',
                    backgroundColor: '#E6ECF0',
                    borderRadius: '100px'
                  }}
                >
                  Scope 3:{' '}
                  <span style={{fontWeight: 'bold'}}>{efData.scope3}</span>
                </div>
              </Flex>
            </Flex>
          );
        })
      ) : (
        <Flex align="center" justify="center">
          No Data Found
        </Flex>
      )} */}
    </div>
  );
};

export default EFDatabase;
